// extracted by mini-css-extract-plugin
export default {"resendContainer":"ConfirmPhone_resendContainer__YGUn7"};